<template>
  <div class="container-fluid">
    <card-title
      title="HISTÓRICO DE BENEFICIOS DE CRECIMIENTO"
      icon="format-align-top"
    >
      <template #content>
        <v-progress-linear v-if="loading" indeterminate color="primary" />
        <v-card v-else class="mx-auto elevation-5" outlined>
          <div>
            <div class="elevation-5">
              <div class="card-body text-lg-center">
                <v-simple-table dense class="d-none d-sm-block">
                  <template #default>
                    <thead>
                      <tr class="text-black custom-body-hs font-size-x">
                        <td class="box-shadow" style="width: 42%">Concepto</td>
                        <td
                          v-for="(item, index) in rebateHeader"
                          :key="index"
                          class="box-shadow"
                        >
                          {{ item }}
                        </td>
                      </tr>
                    </thead>
                    <tbody>
                      <tr class="no-border custom-body-hs font-size-x">
                        <td
                          class="d-flex justify-content-center align-center gap-2"
                        >
                          <router-link
                            v-if="isRebateAvailable"
                            class="text-black text-decoration-underline"
                            :to="{
                              name: 'AccountStatus',
                              params: { disc: 'BR' },
                            }"
                          >
                            Bono rebate
                          </router-link>
                          <span v-else>Bono rebate</span>

                          <register-cash
                            :show-value="false"
                            :cash-register-color="
                              isRebateAvailable ? 'green' : 'grey'
                            "
                            :show-pending-text="false"
                            :show-action-link="false"
                            :disabled-tooltip="false"
                          >
                            <span style="white-space: pre-wrap">
                              Total de bono ganado (importe s/IVA): ${{
                                rebate.amount | removeDecimals
                              }}
                              <br />
                              Total acumulado disponible (importe s/IVA): ${{
                                rebate.available | removeDecimals
                              }}
                            </span>
                          </register-cash>
                        </td>
                        <td v-for="(item, index) in rebateData" :key="index">
                          <register-cash
                            :cash-register-color="
                              index === 2 && isRebateAvailable
                                ? 'green'
                                : 'grey'
                            "
                            :show-pending-text="false"
                            :show-action-link="false"
                            :value="item.REBATE"
                          />
                        </td>
                      </tr>
                      <tr class="no-border custom-body-hs font-size-x">
                        <td
                          class="d-flex justify-content-center align-center gap-2"
                        >
                          <span>Detalle rebate</span>
                        </td>
                        <td v-for="(item, index) in rebateData" :key="index">
                          <span
                            v-if="getRebateYear(item)"
                            class="text-decoration-underline"
                            ><a @click="openModalRebate(item)">Detalle</a></span
                          >
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>
                <!-- Mobile view -->
                <v-simple-table dense class="d-sm-none">
                  <template #default>
                    <thead>
                      <tr class="font-size-x">
                        <td class="box-shadow text-black">Concepto</td>
                        <td class="border">Rebate</td>
                      </tr>
                      <tr
                        v-for="(item, index) in rebateData"
                        :key="index"
                        class="font-size-x"
                      >
                        <td class="box-shadow text-black">
                          {{ rebateHeader[index] }}
                        </td>
                        <td class="border">
                          ${{ currencyFormat(item.REBATE) }}
                        </td>
                      </tr>
                    </thead>
                  </template>
                </v-simple-table>
                <!-- end Mobile view -->
              </div>
            </div>
          </div>
        </v-card>
      </template>
    </card-title>
    <bono-rebate-detail-modal
      v-model="isRebateDetailModalOpen"
      :selected-rebate="selectedRebate"
      :data="rebateDetail"
      @load="getLoadRebateDetail(selectedRebate)"
    />
  </div>
</template>
<script>
  /* eslint-disable vue/require-default-prop, vue/require-prop-types */
  import { mapGetters, mapActions } from 'vuex';
  import CardTitle from '@/components/CardTitle.vue';
  import axios from '@/plugins/axios';
  import mixinservice from '@/mixins/service';
  import RegisterCash from '@/components/RegisterCash.vue';
  import BonoRebateDetailModal from '@/views/growth_benefit_history/components/BonoRebateDetailModal.vue';
  import Quarter from '@/core/models/quarter';

  export default {
    name: 'GrowthBenefitHistory',

    components: {
      CardTitle,
      RegisterCash,
      BonoRebateDetailModal,
    },
    mixins: [mixinservice],
    props: {
      customer: {},
    },
    data() {
      return {
        rebateData: [],
        rebateHeader: [],
        loading: true,
        isRebateDetailModalOpen: false,
        selectedRebate: null,
      };
    },
    computed: {
      isRebateAvailable() {
        return this.rebate?.available > 0;
      },
      ...mapGetters('bonusCustomer', [
        'cashRegister',
        'loadingCashRegister',
        'rebate',
        'rebateDetail',
        'rebateDetailError',
      ]),
    },
    watch: {
      customer() {
        this.rebateData = [];
        this.rebateHeader = [];
        this.loadData();
      },
    },
    methods: {
      ...mapActions('bonusCustomer', ['setRebateDetail']),
      async loadData() {
        let quarters = this.calcularUltimosTrim(4);
        for (let index = 3; index >= 0; index--) {
          let quarter = quarters[index];
          const params = {
            customer_id: this.customer,
            quarter: `0${quarter.trim}`,
            year: quarter.year,
          };
          try {
            const rebate = await axios.post('/cover/rebate', params);
            this.rebateData.push(rebate.data);
          } catch (error) {
            this.rebateData.push({
              REBATE: 0,
              FKIMGA: 0,
            });
          }
          this.rebateHeader.push(Quarter.getPeriodLabel(quarter.trim));
        }
        this.loading = false;
      },
      getRebateYear(item) {
        const quarterParsed = Quarter.parse(item.SPMON);
        const currentYear = new Date().getFullYear().toString();
        return currentYear === quarterParsed.year ? true : false;
      },
      currencyFormat(number = 0) {
        let result = Number(number);
        return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
      openModalRebate(data) {
        this.isRebateDetailModalOpen = true;
        this.selectedRebate = data.SPMON;
        this.getLoadRebateDetail(this.selectedRebate);
      },
      async getLoadRebateDetail(selected) {
        const quarterParsed = Quarter.parse(selected);

        await this.setRebateDetail({
          customer: this.customer,
          quarter: quarterParsed.quarter,
          year: quarterParsed.year,
        });
        if (this.rebateDetailError) {
          this.$toast.error(this.rebateDetailError);
        }
      },
    },
  };
</script>

<style src="@/assets/css/customerHome.css" scoped></style>
